import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const housingData = {
  title: "Répartition des ménages ordinaires par milieu de résidence, province et commune selon le principal matériau du pavement de la maison",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", terre: "21 435", ciment: "929", pierres: "257", carreaux: "25", briques: "103", planches: "3", total: "22 752" },
        { name: "BUTIHINDA", terre: "90 195", ciment: "8 312", pierres: "310", carreaux: "417", briques: "280", planches: "22", total: "99 536" },
        { name: "CANKUZO", terre: "29 282", ciment: "4 082", pierres: "69", carreaux: "101", briques: "149", planches: "15", total: "33 698" },
        { name: "GISAGARA", terre: "56 057", ciment: "5 164", pierres: "232", carreaux: "65", briques: "322", planches: "70", total: "61 910" },
        { name: "GISURU", terre: "59 508", ciment: "4 720", pierres: "1 464", carreaux: "69", briques: "4 388", planches: "17", total: "70 166" },
        { name: "MUYINGA", terre: "91 925", ciment: "13 823", pierres: "417", carreaux: "1 022", briques: "391", planches: "17", total: "107 595" },
        { name: "RUYIGI", terre: "38 510", ciment: "6 429", pierres: "136", carreaux: "195", briques: "426", planches: "5", total: "45 701" }
      ],
      terre: "386 912",
      ciment: "43 459",
      pierres: "2 885",
      carreaux: "1 894",
      briques: "6 059",
      planches: "149",
      total: "441 358"
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", terre: "42 238", ciment: "6 418", pierres: "182", carreaux: "242", briques: "327", planches: "10", total: "49 417" },
        { name: "BUKINANYANA", terre: "48 041", ciment: "7 233", pierres: "444", carreaux: "121", briques: "185", planches: "32", total: "56 056" },
        { name: "CIBITOKE", terre: "42 062", ciment: "12 585", pierres: "847", carreaux: "458", briques: "86", planches: "48", total: "56 086" },
        { name: "ISARE", terre: "24 907", ciment: "4 419", pierres: "702", carreaux: "101", briques: "471", planches: "3", total: "30 603" },
        { name: "MPANDA", terre: "59 701", ciment: "14 564", pierres: "870", carreaux: "503", briques: "214", planches: "75", total: "75 927" },
        { name: "MUGERE", terre: "44 184", ciment: "48 116", pierres: "1 246", carreaux: "16 056", briques: "369", planches: "114", total: "110 085" },
        { name: "MUGINA", terre: "38 421", ciment: "7 683", pierres: "91", carreaux: "108", briques: "208", planches: "17", total: "46 528" },
        { name: "MUHUTA", terre: "19 561", ciment: "3 055", pierres: "341", carreaux: "33", briques: "133", planches: "41", total: "23 164" },
        { name: "MUKAZA", terre: "7 635", ciment: "28 920", pierres: "232", carreaux: "4 619", briques: "71", planches: "63", total: "41 540" },
        { name: "NTAHANGWA", terre: "58 605", ciment: "123 764", pierres: "1 976", carreaux: "30 245", briques: "1 031", planches: "498", total: "216 119" },
        { name: "RWIBAGA", terre: "17 031", ciment: "6 367", pierres: "814", carreaux: "182", briques: "115", planches: "17", total: "24 526" }
      ],
      terre: "402 386",
      ciment: "263 124",
      pierres: "7 745",
      carreaux: "52 668",
      briques: "3 210",
      planches: "918",
      total: "730 051"
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", terre: "29 581", ciment: "10 749", pierres: "477", carreaux: "86", briques: "521", planches: "15", total: "41 429" },
        { name: "MAKAMBA", terre: "64 393", ciment: "11 532", pierres: "493", carreaux: "446", briques: "669", planches: "152", total: "77 685" },
        { name: "MATANA", terre: "30 558", ciment: "12 519", pierres: "165", carreaux: "119", briques: "229", planches: "66", total: "43 656" },
        { name: "MUSONGATI", terre: "63 706", ciment: "4 300", pierres: "2 203", carreaux: "36", briques: "818", planches: "20", total: "71 083" },
        { name: "NYANZA", terre: "56 779", ciment: "17 791", pierres: "505", carreaux: "369", briques: "878", planches: "240", total: "76 562" },
        { name: "RUMONGE", terre: "61 268", ciment: "22 997", pierres: "798", carreaux: "749", briques: "1 617", planches: "111", total: "87 540" },
        { name: "RUTANA", terre: "38 443", ciment: "8 050", pierres: "371", carreaux: "118", briques: "257", planches: "18", total: "47 257" }
      ],
      terre: "344 728",
      ciment: "87 938",
      pierres: "5 012",
      carreaux: "1 923",
      briques: "4 989",
      planches: "622",
      total: "445 212"
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", terre: "74 431", ciment: "5 944", pierres: "287", carreaux: "62", briques: "499", planches: "26", total: "81 249" },
        { name: "KAYANZA", terre: "57 827", ciment: "10 656", pierres: "1 553", carreaux: "416", briques: "3 768", planches: "73", total: "74 293" },
        { name: "KIREMBA", terre: "63 368", ciment: "4 280", pierres: "174", carreaux: "203", briques: "786", planches: "6", total: "68 817" },
        { name: "KIRUNDO", terre: "98 730", ciment: "8 944", pierres: "454", carreaux: "347", briques: "1 416", planches: "50", total: "109 941" },
        { name: "MATONGO", terre: "51 934", ciment: "3 819", pierres: "938", carreaux: "54", briques: "4 420", planches: "37", total: "61 202" },
        { name: "MUHANGA", terre: "50 659", ciment: "2 174", pierres: "601", carreaux: "63", briques: "1 699", planches: "3", total: "55 199" },
        { name: "NGOZI", terre: "52 497", ciment: "17 181", pierres: "1 920", carreaux: "1 412", briques: "3 625", planches: "107", total: "76 742" },
        { name: "TANGARA", terre: "56 702", ciment: "2 901", pierres: "384", carreaux: "54", briques: "695", planches: "18", total: "60 754" }
      ],
      terre: "506 148",
      ciment: "55 899",
      pierres: "6 311",
      carreaux: "2 611",
      briques: "16 908",
      planches: "320",
      total: "588 197"
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", terre: "48 816", ciment: "2 725", pierres: "432", carreaux: "195", briques: "1 826", planches: "19", total: "54 013" },
        { name: "GISHUBI", terre: "53 766", ciment: "4 355", pierres: "200", carreaux: "215", briques: "491", planches: "4", total: "59 031" },
        { name: "GITEGA", terre: "86 284", ciment: "26 887", pierres: "1 973", carreaux: "1 975", briques: "3 176", planches: "58", total: "120 353" },
        { name: "KARUSI", terre: "75 416", ciment: "5 911", pierres: "227", carreaux: "233", briques: "596", planches: "17", total: "82 400" },
        { name: "KIGANDA", terre: "29 009", ciment: "3 501", pierres: "339", carreaux: "88", briques: "1 133", planches: "17", total: "34 087" },
        { name: "MURAMVYA", terre: "27 199", ciment: "7 356", pierres: "826", carreaux: "178", briques: "2 498", planches: "97", total: "38 154" },
        { name: "MWARO", terre: "23 563", ciment: "9 153", pierres: "512", carreaux: "163", briques: "1 384", planches: "26", total: "34 801" },
        { name: "NYABIHANGA", terre: "34 204", ciment: "4 711", pierres: "542", carreaux: "73", briques: "2 098", planches: "22", total: "41 650" },
        { name: "SHOMBO", terre: "51 812", ciment: "2 258", pierres: "179", carreaux: "100", briques: "935", planches: "4", total: "55 288" }
      ],
      terre: "430 069",
      ciment: "66 857",
      pierres: "5 230",
      carreaux: "3 220",
      briques: "14 137",
      planches: "264",
      total: "519 777"
    }
  ],
  total: {
    terre: "2 070 243",
    ciment: "517 277",
    pierres: "27 183",
    carreaux: "62 316",
    briques: "45 303",
    planches: "2 273",
    total: "2 724 595",
    urbain: {
      terre: "250 650",
      ciment: "361 457",
      pierres: "7 389",
      carreaux: "58 314",
      briques: "9 628",
      planches: "1 065",
      total: "688 503"
    },
    rural: {
      terre: "1 819 593",
      ciment: "155 820",
      pierres: "19 794",
      carreaux: "4 002",
      briques: "35 675",
      planches: "1 208",
      total: "2 036 092"
    }
  }
};

const HousingMaterialPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Province/Commune\tTerre\tCiment/Béton\tPierres\tCarreaux\tBriques cuites\tPlanches\tTotal\n";
    
    // Ajout des données totales
    tableContent += `BURUNDI\t${housingData.total.terre}\t${housingData.total.ciment}\t${housingData.total.pierres}\t${housingData.total.carreaux}\t${housingData.total.briques}\t${housingData.total.planches}\t${housingData.total.total}\n`;
    tableContent += `Urbain\t${housingData.total.urbain.terre}\t${housingData.total.urbain.ciment}\t${housingData.total.urbain.pierres}\t${housingData.total.urbain.carreaux}\t${housingData.total.urbain.briques}\t${housingData.total.urbain.planches}\t${housingData.total.urbain.total}\n`;
    tableContent += `Rural\t${housingData.total.rural.terre}\t${housingData.total.rural.ciment}\t${housingData.total.rural.pierres}\t${housingData.total.rural.carreaux}\t${housingData.total.rural.briques}\t${housingData.total.rural.planches}\t${housingData.total.rural.total}\n`;
    
    // Ajout des données par province et commune
    housingData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.terre}\t${province.ciment}\t${province.pierres}\t${province.carreaux}\t${province.briques}\t${province.planches}\t${province.total}\n`;
      
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.terre}\t${commune.ciment}\t${commune.pierres}\t${commune.carreaux}\t${commune.briques}\t${commune.planches}\t${commune.total}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${housingData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données des matériaux de pavement des maisons au Burundi: ${housingData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(housingData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `materiaux-pavement-maisons-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  const filteredProvinces = housingData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);
// Calcul des indicateurs clés
const keyStats = {
  totalHouseholds: housingData.total.total,

  urbanPercentage: (
    (parseFloat(housingData.total.urbain.total.replace(/\s/g, '')) /
    parseFloat(housingData.total.total.replace(/\s/g, ''))) * 100
  ).toFixed(1),

  mostCementProvince: housingData.provinces.reduce((max, province) =>
    parseFloat(province.ciment.replace(/\s/g, '')) > parseFloat(max.ciment.replace(/\s/g, '')) ? province : max
  ),

  mostEarthProvince: housingData.provinces.reduce((max, province) =>
    parseFloat(province.terre.replace(/\s/g, '')) > parseFloat(max.terre.replace(/\s/g, '')) ? province : max
  ),

  highestCementPercentage: housingData.provinces.reduce((max, province) => {
    const cementPct = (
      parseFloat(province.ciment.replace(/\s/g, '')) /
      parseFloat(province.total.replace(/\s/g, ''))
    ) * 100;
    return cementPct > max.cementPct ? { province, cementPct } : max;
  }, { province: null, cementPct: 0 }),

  highestUrbanCementUsage: (
    parseFloat(housingData.total.urbain.ciment.replace(/\s/g, '')) /
    parseFloat(housingData.total.urbain.total.replace(/\s/g, ''))
  ) * 100
};

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
        
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {housingData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6} ></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province/commune..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ménages Totaux
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {housingData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Dont {housingData.total.urbain.total} urbains
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Proportion Urbaine
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.urbanPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                Moyenne nationale
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus d'usage ciment
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostCementProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostCementProvince.ciment}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({keyStats.highestCementPercentage.cementPct.toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ciment en milieu urbain
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestUrbanCementUsage.toFixed(1)}%
                              </Typography>
                              <Typography variant="body2">
                                des maisons urbaines
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des matériaux de pavement">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Terre</TableCell>
                          <TableCell align="right">Ciment/Béton</TableCell>
                          <TableCell align="right">Pierres</TableCell>
                          <TableCell align="right">Carreaux</TableCell>
                          <TableCell align="right">Briques cuites</TableCell>
                          <TableCell align="right">Planches</TableCell>
                          <TableCell align="right">Total</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.terre}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.ciment}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.pierres}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.carreaux}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.briques}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.planches}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{housingData.total.total}</TableCell>
                        </ProvinceRow>

                        {/* Ligne pour le milieu urbain */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ pl: 4 }}>
                            Urbain
                          </TableCell>
                          <TableCell align="right">{housingData.total.urbain.terre}</TableCell>
                          <TableCell align="right">{housingData.total.urbain.ciment}</TableCell>
                          <TableCell align="right">{housingData.total.urbain.pierres}</TableCell>
                          <TableCell align="right">{housingData.total.urbain.carreaux}</TableCell>
                          <TableCell align="right">{housingData.total.urbain.briques}</TableCell>
                          <TableCell align="right">{housingData.total.urbain.planches}</TableCell>
                          <TableCell align="right">{housingData.total.urbain.total}</TableCell>
                        </ProvinceRow>

                        {/* Ligne pour le milieu rural */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ pl: 4 }}>
                            Rural
                          </TableCell>
                          <TableCell align="right">{housingData.total.rural.terre}</TableCell>
                          <TableCell align="right">{housingData.total.rural.ciment}</TableCell>
                          <TableCell align="right">{housingData.total.rural.pierres}</TableCell>
                          <TableCell align="right">{housingData.total.rural.carreaux}</TableCell>
                          <TableCell align="right">{housingData.total.rural.briques}</TableCell>
                          <TableCell align="right">{housingData.total.rural.planches}</TableCell>
                          <TableCell align="right">{housingData.total.rural.total}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.terre}</TableCell>
                              <TableCell align="right">{province.ciment}</TableCell>
                              <TableCell align="right">{province.pierres}</TableCell>
                              <TableCell align="right">{province.carreaux}</TableCell>
                              <TableCell align="right">{province.briques}</TableCell>
                              <TableCell align="right">{province.planches}</TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={8}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.terre}</TableCell>
                                          <TableCell align="right">{commune.ciment}</TableCell>
                                          <TableCell align="right">{commune.pierres}</TableCell>
                                          <TableCell align="right">{commune.carreaux}</TableCell>
                                          <TableCell align="right">{commune.briques}</TableCell>
                                          <TableCell align="right">{commune.planches}</TableCell>
                                          <TableCell align="right">{commune.total}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                      {/* 
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des matériaux de pavement
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Les matériaux de pavement des maisons sont un indicateur important des conditions de vie et du niveau de développement économique. Cette répartition montre:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Terre: Sol naturel, souvent compacté" 
                          secondary="Prédominant en milieu rural (83.7% des ménages ruraux)"
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Ciment/Béton: Matériau moderne et durable" 
                          secondary="Plus fréquent en milieu urbain (52.5% des ménages urbains)"
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Pierres: Matériau traditionnel" 
                          secondary="Utilisé principalement dans certaines régions montagneuses"
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Carreaux: Revêtement de qualité supérieure" 
                          secondary="Principalement en milieu urbain (8.5% des ménages)"
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Ces données montrent une nette différence entre milieux urbain et rural en termes de qualité des habitats.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE) 
    réalisé en 2024. Le matériau de pavement principal présenté ici concerne la répartition des ménages ordinaires selon leur milieu de résidence (urbain/rural), 
    par province et par commune. Les proportions sont calculées par rapport au total des ménages ordinaires pour chaque catégorie.
</Typography>
                                    </Paper>
                                  </Grid>
                                </Grid>
                              </Container>
                            </ContentWrapper>
                          </MainContentWithDrawer>
                          <Footer />
                        </MainContainer>
                      );
                    };
                    
                    export default HousingMaterialPage;